import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBaselinePennant = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17 2.75C18.2426 2.75 19.25 3.75736 19.25 5V19.71C19.25 21.0789 17.7489 21.9184 16.583 21.2012L12.6553 18.7842C12.2535 18.5369 11.7465 18.5369 11.3447 18.7842L7.41699 21.2012C6.25106 21.9184 4.75 21.0789 4.75 19.71V5C4.75 3.75736 5.75736 2.75 7 2.75H17ZM7 4.25C6.58579 4.25 6.25 4.58579 6.25 5V19.71C6.25 19.9054 6.46434 20.026 6.63086 19.9238L10.5586 17.5059C11.4424 16.962 12.5576 16.962 13.4414 17.5059L17.3691 19.9238C17.5357 20.026 17.75 19.9054 17.75 19.71V5C17.75 4.58579 17.4142 4.25 17 4.25H7Z",
		fill: "currentColor"
	})
});
export { SvgIconBaselinePennant as ReactComponent };
